export default {
    mileages: [],
    mileage_firsts: null,
    mileage: null,
    pagination: {
        total: 1,
        current_page: 1,
    },
}
